import { ColumnDef } from '@tanstack/react-table'
import { MiddleTruncatedText } from 'features/knowledgeDocumentViewer/components/MiddleTruncatedText'
import { SensorSearchItem } from 'features/knowledgeDocumentViewer/types/searchableItems'
import { InputType } from 'types'

export const SensorTableColumns = (): ColumnDef<SensorSearchItem>[] => [
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    enableSorting: true,
    sortDescFirst: false,
    enableColumnFilter: true,
    filterFn: 'includesString',
    cell: ({ row }) => (
      <MiddleTruncatedText
        text={row.original.name}
        maxWidth='100%'
        fillWidth
        tooltipFontSize='0.75rem'
      />
    ),
    meta: {
      inputType: InputType.Text,
    },
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: 'Description',
    enableSorting: true,
    sortDescFirst: false,
    enableColumnFilter: true,
    filterFn: 'includesString',
    cell: ({ row }) => <span>{row.original.description || '-'}</span>,
    meta: {
      inputType: InputType.Text,
    },
  },
  {
    id: 'unit',
    accessorKey: 'unit',
    header: 'Unit',
    enableSorting: true,
    sortDescFirst: false,
    enableColumnFilter: false,
    cell: ({ row }) => <span>{row.original.unit || '-'}</span>,
  },
  {
    id: 'asset',
    accessorKey: 'asset',
    header: 'Asset',
    enableSorting: true,
    sortDescFirst: false,
    enableColumnFilter: true,
    filterFn: 'includesString',
    cell: ({ row }) => <span>{row.original.asset || '-'}</span>,
    meta: {
      inputType: InputType.Text,
    },
  },
]
